// When the user scrolls down 50px from the top of the document, resize the header's font size
$(document).scroll(function() {
  scrollFunction();
});
function scrollFunction() {
  if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
    document.getElementById("header").style.minHeight = "30px";
    document.getElementById("logo").style.width = "30px";
  } else {
    document.getElementById("header").style.minHeight = "120px";
    document.getElementById("logo").style.width = "80px";
  }
}

//Audio PopUp
var overlay = $("#overlay"),
  fab = $(".fab"),
  isAudioAllow;
overlay.on("click", closeFAB);
$("#AllowAudio").click(function () {
  isAudioAllow = true;
  ckcInput(isAudioAllow);
  closeFAB(event);
});
$("#DenyAudio").click(function () {
  isAudioAllow = false;
  ckcInput(isAudioAllow);
  closeFAB(event);
});
function ckcInput() {
  var video = document.getElementById("bgVideo");
  if (isAudioAllow == true) {
    video.muted = false;
    $(".UnmuteImg").css("display", "block");
    $(".MuteImg").css("display", "none");
  } else {
    video.muted = true;
    $(".MuteImg").css("display", "block");
    $(".UnmuteImg").css("display", "none");
    $("#MuteButton").addClass("muted");
  }
  video.play();
}
function closeFAB(event) {
  if (event) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
  fab.removeClass("active2");
  overlay.removeClass("dark-overlay");
  ckcInput(false);
}
function toggleMute() {
  var button = document.getElementById("MuteButton");
  var video = document.getElementById("bgVideo");
  if (video.muted) {
    video.muted = false;
    video.muted = false;
    $(".UnmuteImg").css("display", "block");
    $(".MuteImg").css("display", "none");
  } else {
    video.muted = true;
    $(".MuteImg").css("display", "block");
    $(".UnmuteImg").css("display", "none");
  }
  button.classList.toggle("muted");
}

var $videoSrc;
function playPauseVD(elm) {
  var vContainer = $(elm).closest(".video-bg");
  $videoSrc = $(vContainer).find("source").attr("src");
}
window.onload = function () {
  skrollr.init({
    forceHeight: false,
    beforerender: function (data) {
      return data.direction == "down";
    },
  });
};
$(document).ready(function () {
  $(function () {
    new WOW().init();
  });
  $("#myModal").on("shown.bs.modal", function (e) {
    $("#video").attr(
      "src",
      $videoSrc + "?autoplay=1&amp;modestbranding=1&amp;showinfo=0"
    );
    $("#bgVideo").get(0).pause();
  });
  $("#myModal").on("hide.bs.modal", function (e) {
    $("#video").attr("src", "");
    $("#bgVideo").get(0).play();
  });
  $(".dropdown-item").click(function () {
    $(".navbar .close-nav").removeClass("show");
  });
  var swiperZoom = new Swiper(".swiper-container2", {
    grabCursor: true,
    direction: "horizontal",
    centeredSlides: true,
    slidesPerView: "2",
    spaceBetween: 25,
    effect: "coverflow",
    simulateTouch: false,
    loop: true,
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 40,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 50,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    keyboard: true,
    coverflowEffect: {
      rotate: 0,
      stretch: 0,
      depth: 100,
      modifier: 4,
      slideShadows: false,
    },
  });
  var currentActiveSlide = $(".swiper-container2 .swiper-slide-active img");
  var fst = currentActiveSlide.data("gifurl");
  var img = new Image();
  img.onload = function () {
    currentActiveSlide.attr("src", "").attr("src", fst);
  };
  img.src = fst;
  swiperZoom.on("realIndexChange", function (e) {
    var currentSlide = swiperZoom.slides[swiperZoom.activeIndex];
    var nextCurrentGifSrc = $(currentSlide).find("img").data("gifurl");
    var currentPngSrc = $(".swiper-container2 .swiper-slide-active img").data(
      "pngurl"
    );
    $(".swiper-container2 .swiper-slide-active img")
      .attr("src", "")
      .attr("src", currentPngSrc); //sets Png
    var img = new Image();
    img.onload = function () {
      if ($(currentSlide).hasClass("swiper-slide-active")) {
        $(currentSlide)
          .find("img")
          .attr("src", "")
          .attr("src", nextCurrentGifSrc); //sets Gif
      }
    };
    img.src = nextCurrentGifSrc;
    //for change Discription
    var slideIndex = $(currentSlide).data("swiper-slide-index");
    $(".toFade").each(function (i, obj) {
      if (slideIndex == i) $(this).show();
      else $(this).hide();
    });
  });

  var tabs = document.querySelector(".tabs-buttons .swiper-wrapper");
  var tabButtons = new Swiper(".tabs-buttons", {
    slidesPerView: "auto",
    freeMode: true,
    simulateTouch: true,
    mousewheelControl: false,
    watchSlidesProgress: true,
  });

  tabButtons.slides.each(function (index, val) {
    var ele = $(this);
    ele.on("click", function (event) {
      if (
        event.target.classList.contains("swiper-slide") &&
        !event.target.classList.contains("active-tab")
      ) {
        event.target.parentElement
          .querySelector(".active-tab")
          .classList.remove("active-tab");
        event.target.classList.add("active-tab");
        tabContent.slideTo(index);
      }
    });
  });
  var tabContent = new Swiper(".tabs-content", {
    centeredSlides: true,
    slidesPerView: 2,
    spaceBetween: 20,
    grabCursor: true,
    simulateTouch: true,
    breakpoints: {
      640: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 50,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: tabButtons,
    },
  });
  tabContent.on("slideChange", function () {
    var index = this.activeIndex;
    $(".tabs-buttons .swiper-container .swiper-slide")
      .removeClass("active-tab")
      .eq(this.activeIndex)
      .addClass("active-tab");
  });
});
var swiper = new Swiper(".mySwiper", {
  spaceBetween: 30,
  slidesPerView: "5",
  centeredSlides: true,
  loop: true,
  watchSlidesVisibility: true,
  breakpoints: {
    640: {
      slidesPerView: 1,
      spaceBetween: 100,
    },
    768: {
      slidesPerView: 1,
      spaceBetween: 40,
    },
    1024: {
      slidesPerView: 2,
      spaceBetween: 50,
    },
  },
  loopFillGroupWithBlank: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
